import * as SchemaTypes from './graphql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export const BannerDocumentBlockFragmentDoc = gql`
    fragment BannerDocumentBlock on BannerDocumentBlock {
  id
  title
  type
  headline
  subheadline
  buttonTarget
  buttonText
  logoImageFormats {
    sixteenByTen {
      medium
    }
  }
  mainImageFormats {
    sixteenBySeven {
      large
    }
    threeByFive {
      medium
    }
  }
}
    `;
export const ContinueWatchingDocumentBlockFragmentDoc = gql`
    fragment ContinueWatchingDocumentBlock on ContinueWatchingDocumentBlock {
  id
  title
  type
}
    `;
export const LivestreamBannerDocumentBlockFragmentDoc = gql`
    fragment LivestreamBannerDocumentBlock on LivestreamBannerDocumentBlock {
  id
  description
  livestreamIri
  title
  type
  media {
    id
    iri
    contentType
    details {
      id
      streamState
      startDate
      endDate
    }
    mediaDuration
    mediaType
    slug
    seriesSlug
    teaserImageFormats {
      sixteenByNine {
        medium
      }
      threeByFour {
        medium
      }
    }
    title
  }
}
    `;
export const RasterDocumentBlockFragmentDoc = gql`
    fragment RasterDocumentBlock on RasterDocumentBlock {
  id
  categories {
    id
    iri
    title
    slug
  }
  title
  categoriesFilter
  podcastFilter
  sort
  sortDirection
  type
  typeFilter
  vmsContext
  tags
}
    `;
export const RemoteContentDocumentBlockFragmentDoc = gql`
    fragment RemoteContentDocumentBlock on RemoteContentDocumentBlock {
  id
  title
  text
  type
}
    `;
export const SliderMediaTeaserFragmentDoc = gql`
    fragment SliderMediaTeaser on Media {
  id
  iri
  backgroundImageFormats {
    sixteenByNine {
      medium
    }
    sixteenBySeven {
      medium
    }
    eightByFive {
      medium
    }
  }
  categories {
    id
    title
    slug
    iri
    contentType
  }
  contentType
  details {
    id
    streamState
    startDate
    endDate
  }
  fskRating
  logoImageFormats {
    sixteenBySeven {
      medium
    }
    sixteenByTen {
      medium
    }
  }
  mediaDuration
  mediaType
  mediaQuality
  products {
    access {
      allowed
      endDate
      period
      reason
    }
    availableProducts {
      id
      iri
      lifetime
      price
      type
    }
  }
  seriesSlug
  series {
    id
    iri
    contentType
    type
    slug
    title
  }
  shortDescription
  slug
  title
  trailers {
    id
    iri
    contentType
    mediaType
    title
    slug
  }
  geoRestrictions {
    allowedRegions
    deniedRegions
  }
  tags
}
    `;
export const SliderSeriesTeaserFragmentDoc = gql`
    fragment SliderSeriesTeaser on Series {
  id
  iri
  backgroundImageFormats {
    sixteenByNine {
      medium
    }
    sixteenBySeven {
      medium
    }
    eightByFive {
      medium
    }
  }
  categories {
    id
    iri
    title
    slug
    contentType
  }
  contentType
  fskRating
  logoImage
  logoImageFormats {
    sixteenBySeven {
      medium
    }
  }
  type
  slug
  shortDescription
  title
  trailers {
    id
    iri
    contentType
    title
    slug
  }
}
    `;
export const SliderDocumentBlockFragmentDoc = gql`
    fragment SliderDocumentBlock on SliderDocumentBlock {
  id
  title
  type
  items {
    ...SliderMediaTeaser
    ...SliderSeriesTeaser
  }
}
    ${SliderMediaTeaserFragmentDoc}
${SliderSeriesTeaserFragmentDoc}`;
export const MediaTeaserFragmentDoc = gql`
    fragment MediaTeaser on Media {
  id
  iri
  slug
  categories {
    id
    iri
    title
    slug
    contentType
  }
  contentType
  details {
    id
    streamState
    startDate
    endDate
  }
  episodeNumber
  fskRating
  mediaDuration
  mediaQuality
  mediaType
  seriesSlug
  series {
    id
    iri
    contentType
    type
    slug
    title
    categories {
      id
      iri
      title
      slug
      contentType
    }
  }
  title
  teaserDescription
  teaserImageFormats {
    sixteenByNine {
      medium
    }
    threeByFour {
      medium
    }
  }
  year
  isDrmProtected
  liveDate
}
    `;
export const SeriesTeaserFragmentDoc = gql`
    fragment SeriesTeaser on Series {
  id
  iri
  categories {
    id
    iri
    title
    slug
    contentType
  }
  contentType
  fskRating
  slug
  teaserDescription
  teaserImageFormats {
    sixteenByNine {
      medium
    }
    threeByFour {
      medium
    }
  }
  title
}
    `;
export const StudioTeaserFragmentDoc = gql`
    fragment StudioTeaser on Studio {
  id
  contentType
  iri
  logoImage
  teaserImageFormats {
    fourByThree {
      medium
    }
    threeByFour {
      medium
    }
    sixteenByNine {
      medium
    }
  }
  logoImageFormats {
    oneByOne {
      medium
    }
    threeByFour {
      medium
    }
  }
  slug
  teaserDescription
  title
}
    `;
export const CategoryTeaserFragmentDoc = gql`
    fragment CategoryTeaser on Category {
  id
  contentType
  iri
  slug
  title
  logoImageFormats {
    oneByOne {
      medium
    }
  }
}
    `;
export const TeaserlaneDocumentBlockFragmentDoc = gql`
    fragment TeaserlaneDocumentBlock on TeaserLaneDocumentBlock {
  id
  title
  type
  items {
    ...MediaTeaser
    ...SeriesTeaser
    ...StudioTeaser
    ...CategoryTeaser
  }
  teaserVariant
}
    ${MediaTeaserFragmentDoc}
${SeriesTeaserFragmentDoc}
${StudioTeaserFragmentDoc}
${CategoryTeaserFragmentDoc}`;
export const TeaserlaneGenericDocumentBlockFragmentDoc = gql`
    fragment TeaserlaneGenericDocumentBlock on TeaserLaneGenericDocumentBlock {
  id
  categoriesFilter
  title
  type
  teaserCollection {
    items {
      ...MediaTeaser
      ...StudioTeaser
      ...CategoryTeaser
      ...SeriesTeaser
    }
    page
    totalItems
    hasMore
  }
  teaserVariant
  vmsContext
  tags
  progressiveLoad
  sort
  sortDirection
  typeFilter
  podcastFilter
}
    ${MediaTeaserFragmentDoc}
${StudioTeaserFragmentDoc}
${CategoryTeaserFragmentDoc}
${SeriesTeaserFragmentDoc}`;
export const TextDocumentBlockFragmentDoc = gql`
    fragment TextDocumentBlock on TextDocumentBlock {
  id
  title
  text
  type
}
    `;
export const CreateFavoriteItemDocument = gql`
    mutation CreateFavoriteItem($profileId: Int!, $iri: String!) {
  createFavorite(profileId: $profileId, iri: $iri) {
    ... on FavoriteItem {
      id
      iri
      contentType
      mediaType
      isMediaLive
    }
    ... on CreateFavoriteError {
      iri
      error
    }
  }
}
    `;
export type CreateFavoriteItemMutationFn = Apollo.MutationFunction<SchemaTypes.CreateFavoriteItemMutation, SchemaTypes.CreateFavoriteItemMutationVariables>;

/**
 * __useCreateFavoriteItemMutation__
 *
 * To run a mutation, you first call `useCreateFavoriteItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFavoriteItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFavoriteItemMutation, { data, loading, error }] = useCreateFavoriteItemMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      iri: // value for 'iri'
 *   },
 * });
 */
export function useCreateFavoriteItemMutation(baseOptions?: Apollo.MutationHookOptions<SchemaTypes.CreateFavoriteItemMutation, SchemaTypes.CreateFavoriteItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SchemaTypes.CreateFavoriteItemMutation, SchemaTypes.CreateFavoriteItemMutationVariables>(CreateFavoriteItemDocument, options);
      }
export type CreateFavoriteItemMutationHookResult = ReturnType<typeof useCreateFavoriteItemMutation>;
export type CreateFavoriteItemMutationResult = Apollo.MutationResult<SchemaTypes.CreateFavoriteItemMutation>;
export type CreateFavoriteItemMutationOptions = Apollo.BaseMutationOptions<SchemaTypes.CreateFavoriteItemMutation, SchemaTypes.CreateFavoriteItemMutationVariables>;
export const DeleteFavoriteItemDocument = gql`
    mutation DeleteFavoriteItem($profileId: Int!, $id: Int!) {
  deleteFavorite(profileId: $profileId, id: $id) {
    ... on DeleteFavoriteError {
      id
      error
    }
    ... on DeleteFavoriteSuccess {
      id
    }
  }
}
    `;
export type DeleteFavoriteItemMutationFn = Apollo.MutationFunction<SchemaTypes.DeleteFavoriteItemMutation, SchemaTypes.DeleteFavoriteItemMutationVariables>;

/**
 * __useDeleteFavoriteItemMutation__
 *
 * To run a mutation, you first call `useDeleteFavoriteItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFavoriteItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFavoriteItemMutation, { data, loading, error }] = useDeleteFavoriteItemMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFavoriteItemMutation(baseOptions?: Apollo.MutationHookOptions<SchemaTypes.DeleteFavoriteItemMutation, SchemaTypes.DeleteFavoriteItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SchemaTypes.DeleteFavoriteItemMutation, SchemaTypes.DeleteFavoriteItemMutationVariables>(DeleteFavoriteItemDocument, options);
      }
export type DeleteFavoriteItemMutationHookResult = ReturnType<typeof useDeleteFavoriteItemMutation>;
export type DeleteFavoriteItemMutationResult = Apollo.MutationResult<SchemaTypes.DeleteFavoriteItemMutation>;
export type DeleteFavoriteItemMutationOptions = Apollo.BaseMutationOptions<SchemaTypes.DeleteFavoriteItemMutation, SchemaTypes.DeleteFavoriteItemMutationVariables>;
export const GetAnnouncementDocument = gql`
    query GetAnnouncement {
  announcement {
    id
    title
    url
    startDate
    endDate
  }
}
    `;

/**
 * __useGetAnnouncementQuery__
 *
 * To run a query within a React component, call `useGetAnnouncementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnouncementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnouncementQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAnnouncementQuery(baseOptions?: Apollo.QueryHookOptions<SchemaTypes.GetAnnouncementQuery, SchemaTypes.GetAnnouncementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaTypes.GetAnnouncementQuery, SchemaTypes.GetAnnouncementQueryVariables>(GetAnnouncementDocument, options);
      }
export function useGetAnnouncementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaTypes.GetAnnouncementQuery, SchemaTypes.GetAnnouncementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaTypes.GetAnnouncementQuery, SchemaTypes.GetAnnouncementQueryVariables>(GetAnnouncementDocument, options);
        }
export type GetAnnouncementQueryHookResult = ReturnType<typeof useGetAnnouncementQuery>;
export type GetAnnouncementLazyQueryHookResult = ReturnType<typeof useGetAnnouncementLazyQuery>;
export type GetAnnouncementQueryResult = Apollo.QueryResult<SchemaTypes.GetAnnouncementQuery, SchemaTypes.GetAnnouncementQueryVariables>;
export const GetButtonParadeDataDocument = gql`
    query GetButtonParadeData($mediaIri: String!) {
  media(path: $mediaIri) {
    id
    details {
      startDate
      endDate
      streamState
    }
    iri
    slug
    seriesSlug
    mediaType
    contentType
    title
    teaserDescription
    episodeNumber
    trailers {
      id
      iri
      title
      slug
    }
    products {
      access {
        allowed
        endDate
        period
        reason
      }
      availableProducts {
        id
        iri
        lifetime
        price
        type
        walletTariffName
      }
    }
    geoRestrictions {
      allowedRegions
      deniedRegions
    }
    tags
    season {
      id
    }
  }
}
    `;

/**
 * __useGetButtonParadeDataQuery__
 *
 * To run a query within a React component, call `useGetButtonParadeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetButtonParadeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetButtonParadeDataQuery({
 *   variables: {
 *      mediaIri: // value for 'mediaIri'
 *   },
 * });
 */
export function useGetButtonParadeDataQuery(baseOptions: Apollo.QueryHookOptions<SchemaTypes.GetButtonParadeDataQuery, SchemaTypes.GetButtonParadeDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaTypes.GetButtonParadeDataQuery, SchemaTypes.GetButtonParadeDataQueryVariables>(GetButtonParadeDataDocument, options);
      }
export function useGetButtonParadeDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaTypes.GetButtonParadeDataQuery, SchemaTypes.GetButtonParadeDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaTypes.GetButtonParadeDataQuery, SchemaTypes.GetButtonParadeDataQueryVariables>(GetButtonParadeDataDocument, options);
        }
export type GetButtonParadeDataQueryHookResult = ReturnType<typeof useGetButtonParadeDataQuery>;
export type GetButtonParadeDataLazyQueryHookResult = ReturnType<typeof useGetButtonParadeDataLazyQuery>;
export type GetButtonParadeDataQueryResult = Apollo.QueryResult<SchemaTypes.GetButtonParadeDataQuery, SchemaTypes.GetButtonParadeDataQueryVariables>;
export const GetCategoryPageDocument = gql`
    query GetCategoryPage($params: CategoryParams!) {
  categories(params: $params) {
    totalItems
    hasMore
    page
    items {
      id
      title
      iri
      slug
      contentType
      theme {
        id
        title
        backgroundImageFormats {
          sixteenBySeven {
            large
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCategoryPageQuery__
 *
 * To run a query within a React component, call `useGetCategoryPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryPageQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetCategoryPageQuery(baseOptions: Apollo.QueryHookOptions<SchemaTypes.GetCategoryPageQuery, SchemaTypes.GetCategoryPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaTypes.GetCategoryPageQuery, SchemaTypes.GetCategoryPageQueryVariables>(GetCategoryPageDocument, options);
      }
export function useGetCategoryPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaTypes.GetCategoryPageQuery, SchemaTypes.GetCategoryPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaTypes.GetCategoryPageQuery, SchemaTypes.GetCategoryPageQueryVariables>(GetCategoryPageDocument, options);
        }
export type GetCategoryPageQueryHookResult = ReturnType<typeof useGetCategoryPageQuery>;
export type GetCategoryPageLazyQueryHookResult = ReturnType<typeof useGetCategoryPageLazyQuery>;
export type GetCategoryPageQueryResult = Apollo.QueryResult<SchemaTypes.GetCategoryPageQuery, SchemaTypes.GetCategoryPageQueryVariables>;
export const GetContinueWatchingCollectionDocument = gql`
    query GetContinueWatchingCollection($params: ContinueWatchingCollectionParams!) {
  continueWatchingCollection(params: $params) {
    items {
      id
      createdAt
      mediaIri
      currentTime
      mediaDuration
      highestTime
      lastTime
      modifiedAt
      state
      seriesIri
    }
  }
}
    `;

/**
 * __useGetContinueWatchingCollectionQuery__
 *
 * To run a query within a React component, call `useGetContinueWatchingCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContinueWatchingCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContinueWatchingCollectionQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetContinueWatchingCollectionQuery(baseOptions: Apollo.QueryHookOptions<SchemaTypes.GetContinueWatchingCollectionQuery, SchemaTypes.GetContinueWatchingCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaTypes.GetContinueWatchingCollectionQuery, SchemaTypes.GetContinueWatchingCollectionQueryVariables>(GetContinueWatchingCollectionDocument, options);
      }
export function useGetContinueWatchingCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaTypes.GetContinueWatchingCollectionQuery, SchemaTypes.GetContinueWatchingCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaTypes.GetContinueWatchingCollectionQuery, SchemaTypes.GetContinueWatchingCollectionQueryVariables>(GetContinueWatchingCollectionDocument, options);
        }
export type GetContinueWatchingCollectionQueryHookResult = ReturnType<typeof useGetContinueWatchingCollectionQuery>;
export type GetContinueWatchingCollectionLazyQueryHookResult = ReturnType<typeof useGetContinueWatchingCollectionLazyQuery>;
export type GetContinueWatchingCollectionQueryResult = Apollo.QueryResult<SchemaTypes.GetContinueWatchingCollectionQuery, SchemaTypes.GetContinueWatchingCollectionQueryVariables>;
export const GetContinueWatchingItemsDocument = gql`
    query GetContinueWatchingItems($paths: [String!]!) {
  mediasByPaths(paths: $paths) {
    id
    iri
    slug
    title
    episodeNumber
    mediaDuration
    contentType
    mediaType
    seriesSlug
    season {
      id
      seasonNumber
    }
    series {
      id
      title
      contentType
      slug
    }
    mediaDuration
    teaserImageFormats {
      sixteenByNine {
        medium
      }
    }
  }
}
    `;

/**
 * __useGetContinueWatchingItemsQuery__
 *
 * To run a query within a React component, call `useGetContinueWatchingItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContinueWatchingItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContinueWatchingItemsQuery({
 *   variables: {
 *      paths: // value for 'paths'
 *   },
 * });
 */
export function useGetContinueWatchingItemsQuery(baseOptions: Apollo.QueryHookOptions<SchemaTypes.GetContinueWatchingItemsQuery, SchemaTypes.GetContinueWatchingItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaTypes.GetContinueWatchingItemsQuery, SchemaTypes.GetContinueWatchingItemsQueryVariables>(GetContinueWatchingItemsDocument, options);
      }
export function useGetContinueWatchingItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaTypes.GetContinueWatchingItemsQuery, SchemaTypes.GetContinueWatchingItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaTypes.GetContinueWatchingItemsQuery, SchemaTypes.GetContinueWatchingItemsQueryVariables>(GetContinueWatchingItemsDocument, options);
        }
export type GetContinueWatchingItemsQueryHookResult = ReturnType<typeof useGetContinueWatchingItemsQuery>;
export type GetContinueWatchingItemsLazyQueryHookResult = ReturnType<typeof useGetContinueWatchingItemsLazyQuery>;
export type GetContinueWatchingItemsQueryResult = Apollo.QueryResult<SchemaTypes.GetContinueWatchingItemsQuery, SchemaTypes.GetContinueWatchingItemsQueryVariables>;
export const GetEpisodesForSeasonDocument = gql`
    query GetEpisodesForSeason($seasonId: Int!) {
  seasonById(seasonId: $seasonId) {
    id
    episodes {
      ...MediaTeaser
      ... on Media {
        products {
          access {
            allowed
            product {
              id
              iri
            }
            reason
          }
          availableProducts {
            id
            iri
            price
            type
          }
        }
      }
    }
  }
}
    ${MediaTeaserFragmentDoc}`;

/**
 * __useGetEpisodesForSeasonQuery__
 *
 * To run a query within a React component, call `useGetEpisodesForSeasonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEpisodesForSeasonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEpisodesForSeasonQuery({
 *   variables: {
 *      seasonId: // value for 'seasonId'
 *   },
 * });
 */
export function useGetEpisodesForSeasonQuery(baseOptions: Apollo.QueryHookOptions<SchemaTypes.GetEpisodesForSeasonQuery, SchemaTypes.GetEpisodesForSeasonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaTypes.GetEpisodesForSeasonQuery, SchemaTypes.GetEpisodesForSeasonQueryVariables>(GetEpisodesForSeasonDocument, options);
      }
export function useGetEpisodesForSeasonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaTypes.GetEpisodesForSeasonQuery, SchemaTypes.GetEpisodesForSeasonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaTypes.GetEpisodesForSeasonQuery, SchemaTypes.GetEpisodesForSeasonQueryVariables>(GetEpisodesForSeasonDocument, options);
        }
export type GetEpisodesForSeasonQueryHookResult = ReturnType<typeof useGetEpisodesForSeasonQuery>;
export type GetEpisodesForSeasonLazyQueryHookResult = ReturnType<typeof useGetEpisodesForSeasonLazyQuery>;
export type GetEpisodesForSeasonQueryResult = Apollo.QueryResult<SchemaTypes.GetEpisodesForSeasonQuery, SchemaTypes.GetEpisodesForSeasonQueryVariables>;
export const GetFavoritesForProfileDocument = gql`
    query GetFavoritesForProfile($profileId: Int!) {
  favorites(profileId: $profileId) {
    id
    iri
    isMediaLive
    contentType
    mediaType
  }
}
    `;

/**
 * __useGetFavoritesForProfileQuery__
 *
 * To run a query within a React component, call `useGetFavoritesForProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFavoritesForProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFavoritesForProfileQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useGetFavoritesForProfileQuery(baseOptions: Apollo.QueryHookOptions<SchemaTypes.GetFavoritesForProfileQuery, SchemaTypes.GetFavoritesForProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaTypes.GetFavoritesForProfileQuery, SchemaTypes.GetFavoritesForProfileQueryVariables>(GetFavoritesForProfileDocument, options);
      }
export function useGetFavoritesForProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaTypes.GetFavoritesForProfileQuery, SchemaTypes.GetFavoritesForProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaTypes.GetFavoritesForProfileQuery, SchemaTypes.GetFavoritesForProfileQueryVariables>(GetFavoritesForProfileDocument, options);
        }
export type GetFavoritesForProfileQueryHookResult = ReturnType<typeof useGetFavoritesForProfileQuery>;
export type GetFavoritesForProfileLazyQueryHookResult = ReturnType<typeof useGetFavoritesForProfileLazyQuery>;
export type GetFavoritesForProfileQueryResult = Apollo.QueryResult<SchemaTypes.GetFavoritesForProfileQuery, SchemaTypes.GetFavoritesForProfileQueryVariables>;
export const GetMediaAndProductsDocument = gql`
    query GetMediaAndProducts($mediaIri: String!) {
  media(path: $mediaIri) {
    id
    mediaType
    contentType
    title
    episodeNumber
    products {
      access {
        allowed
        endDate
        period
        reason
      }
      availableProducts {
        id
        iri
        lifetime
        price
        type
      }
    }
  }
}
    `;

/**
 * __useGetMediaAndProductsQuery__
 *
 * To run a query within a React component, call `useGetMediaAndProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaAndProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMediaAndProductsQuery({
 *   variables: {
 *      mediaIri: // value for 'mediaIri'
 *   },
 * });
 */
export function useGetMediaAndProductsQuery(baseOptions: Apollo.QueryHookOptions<SchemaTypes.GetMediaAndProductsQuery, SchemaTypes.GetMediaAndProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaTypes.GetMediaAndProductsQuery, SchemaTypes.GetMediaAndProductsQueryVariables>(GetMediaAndProductsDocument, options);
      }
export function useGetMediaAndProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaTypes.GetMediaAndProductsQuery, SchemaTypes.GetMediaAndProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaTypes.GetMediaAndProductsQuery, SchemaTypes.GetMediaAndProductsQueryVariables>(GetMediaAndProductsDocument, options);
        }
export type GetMediaAndProductsQueryHookResult = ReturnType<typeof useGetMediaAndProductsQuery>;
export type GetMediaAndProductsLazyQueryHookResult = ReturnType<typeof useGetMediaAndProductsLazyQuery>;
export type GetMediaAndProductsQueryResult = Apollo.QueryResult<SchemaTypes.GetMediaAndProductsQuery, SchemaTypes.GetMediaAndProductsQueryVariables>;
export const GetMediaExtrasDocument = gql`
    query GetMediaExtras($mediaIri: String!) {
  extrasForMedia(mediaIri: $mediaIri) {
    id
    iri
    title
    mediaType
    shortDescription
    teaserDescription
    teaserImageFormats {
      sixteenByNine {
        medium
      }
    }
  }
}
    `;

/**
 * __useGetMediaExtrasQuery__
 *
 * To run a query within a React component, call `useGetMediaExtrasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaExtrasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMediaExtrasQuery({
 *   variables: {
 *      mediaIri: // value for 'mediaIri'
 *   },
 * });
 */
export function useGetMediaExtrasQuery(baseOptions: Apollo.QueryHookOptions<SchemaTypes.GetMediaExtrasQuery, SchemaTypes.GetMediaExtrasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaTypes.GetMediaExtrasQuery, SchemaTypes.GetMediaExtrasQueryVariables>(GetMediaExtrasDocument, options);
      }
export function useGetMediaExtrasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaTypes.GetMediaExtrasQuery, SchemaTypes.GetMediaExtrasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaTypes.GetMediaExtrasQuery, SchemaTypes.GetMediaExtrasQueryVariables>(GetMediaExtrasDocument, options);
        }
export type GetMediaExtrasQueryHookResult = ReturnType<typeof useGetMediaExtrasQuery>;
export type GetMediaExtrasLazyQueryHookResult = ReturnType<typeof useGetMediaExtrasLazyQuery>;
export type GetMediaExtrasQueryResult = Apollo.QueryResult<SchemaTypes.GetMediaExtrasQuery, SchemaTypes.GetMediaExtrasQueryVariables>;
export const GetMediaForCheckoutDocument = gql`
    query GetMediaForCheckout($mediaIri: String!) {
  media(path: $mediaIri) {
    id
    iri
    title
    mediaType
    contentType
    episodeNumber
    mediaDuration
    mediaQuality
    products {
      availableProducts {
        id
        iri
        price
        type
        lifetime
      }
    }
  }
}
    `;

/**
 * __useGetMediaForCheckoutQuery__
 *
 * To run a query within a React component, call `useGetMediaForCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaForCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMediaForCheckoutQuery({
 *   variables: {
 *      mediaIri: // value for 'mediaIri'
 *   },
 * });
 */
export function useGetMediaForCheckoutQuery(baseOptions: Apollo.QueryHookOptions<SchemaTypes.GetMediaForCheckoutQuery, SchemaTypes.GetMediaForCheckoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaTypes.GetMediaForCheckoutQuery, SchemaTypes.GetMediaForCheckoutQueryVariables>(GetMediaForCheckoutDocument, options);
      }
export function useGetMediaForCheckoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaTypes.GetMediaForCheckoutQuery, SchemaTypes.GetMediaForCheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaTypes.GetMediaForCheckoutQuery, SchemaTypes.GetMediaForCheckoutQueryVariables>(GetMediaForCheckoutDocument, options);
        }
export type GetMediaForCheckoutQueryHookResult = ReturnType<typeof useGetMediaForCheckoutQuery>;
export type GetMediaForCheckoutLazyQueryHookResult = ReturnType<typeof useGetMediaForCheckoutLazyQuery>;
export type GetMediaForCheckoutQueryResult = Apollo.QueryResult<SchemaTypes.GetMediaForCheckoutQuery, SchemaTypes.GetMediaForCheckoutQueryVariables>;
export const GetMediaPageDocument = gql`
    query GetMediaPage($slug: String!, $contentType: ContentType!, $eventId: String = null) {
  mediaBySlug(slug: $slug, contentType: $contentType, eventId: $eventId) {
    id
    title
    slug
    seriesSlug
    iri
    attributes {
      id
      name
      type
      values
      isSearchable
    }
    availableQualities
    backgroundImageFormats {
      sixteenByNine {
        large
      }
      threeByFive {
        medium
      }
    }
    categories {
      id
      iri
      contentType
      slug
      title
    }
    contentType
    details {
      id
      streamState
      startDate
      endDate
    }
    extras {
      ...MediaTeaser
    }
    fskRating
    killDate
    leadin
    liveDate
    mediaDuration
    mediaLanguages
    mediaQuality
    mediaType
    description
    shortDescription
    subtitleLanguages
    teaserDescription
    year
    tags
    theme {
      id
      title
    }
    logoImageFormats {
      oneByOne {
        medium
      }
      sixteenBySeven {
        medium
      }
    }
    trailers {
      id
      iri
      contentType
      title
      slug
    }
    products {
      access {
        allowed
        endDate
        period
        reason
      }
      availableProducts {
        id
        iri
        lifetime
        price
        type
        walletTariffName
      }
    }
    recommendations {
      ...MediaTeaser
    }
    studio {
      id
      iri
      contentType
      slug
      title
      logoImageFormats {
        oneByOne {
          small
        }
      }
    }
    teaserImageFormats {
      sixteenByNine {
        medium
      }
    }
    geoRestrictions {
      allowedRegions
      deniedRegions
    }
    tags
  }
}
    ${MediaTeaserFragmentDoc}`;

/**
 * __useGetMediaPageQuery__
 *
 * To run a query within a React component, call `useGetMediaPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMediaPageQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      contentType: // value for 'contentType'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetMediaPageQuery(baseOptions: Apollo.QueryHookOptions<SchemaTypes.GetMediaPageQuery, SchemaTypes.GetMediaPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaTypes.GetMediaPageQuery, SchemaTypes.GetMediaPageQueryVariables>(GetMediaPageDocument, options);
      }
export function useGetMediaPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaTypes.GetMediaPageQuery, SchemaTypes.GetMediaPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaTypes.GetMediaPageQuery, SchemaTypes.GetMediaPageQueryVariables>(GetMediaPageDocument, options);
        }
export type GetMediaPageQueryHookResult = ReturnType<typeof useGetMediaPageQuery>;
export type GetMediaPageLazyQueryHookResult = ReturnType<typeof useGetMediaPageLazyQuery>;
export type GetMediaPageQueryResult = Apollo.QueryResult<SchemaTypes.GetMediaPageQuery, SchemaTypes.GetMediaPageQueryVariables>;
export const GetMediaPlayerDataDocument = gql`
    query GetMediaPlayerData($mediaIri: String!) {
  media(path: $mediaIri) {
    id
    iri
    categories {
      id
      iri
      contentType
      slug
      title
    }
    contentType
    endCreditsTimeMarker
    fskRating
    mediaType
    posterImage {
      large
    }
    tags
    playerData {
      source {
        url
        duration
        isDrmProtected
        tracks {
          ... on StandardTrack {
            url
            language
          }
          ... on ProtectedTrack {
            url
            language
            streamingProtocol
            protectionScheme
            segmentType
            externalAssetId
          }
          ... on LivestreamTrack {
            url
            language
            externalStreamId
            externalStreamName
          }
        }
      }
      subtitles {
        assetFormats {
          language
          contentUrl
        }
      }
      rolls {
        source {
          url
          duration
          tracks {
            ... on StandardTrack {
              url
              language
            }
          }
        }
        iri
        type
        isSkippable
      }
      product {
        id
        price
        type
      }
    }
    seriesSlug
    showNextEpisodeButton
    slug
    state
    studio {
      id
      iri
      contentType
      title
      slug
    }
    season {
      id
      series {
        id
        iri
        contentType
        title
        slug
      }
    }
    title
    isDrmProtected
    enableAutoSubtitles
    details {
      id
      streamState
    }
  }
}
    `;

/**
 * __useGetMediaPlayerDataQuery__
 *
 * To run a query within a React component, call `useGetMediaPlayerDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaPlayerDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMediaPlayerDataQuery({
 *   variables: {
 *      mediaIri: // value for 'mediaIri'
 *   },
 * });
 */
export function useGetMediaPlayerDataQuery(baseOptions: Apollo.QueryHookOptions<SchemaTypes.GetMediaPlayerDataQuery, SchemaTypes.GetMediaPlayerDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaTypes.GetMediaPlayerDataQuery, SchemaTypes.GetMediaPlayerDataQueryVariables>(GetMediaPlayerDataDocument, options);
      }
export function useGetMediaPlayerDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaTypes.GetMediaPlayerDataQuery, SchemaTypes.GetMediaPlayerDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaTypes.GetMediaPlayerDataQuery, SchemaTypes.GetMediaPlayerDataQueryVariables>(GetMediaPlayerDataDocument, options);
        }
export type GetMediaPlayerDataQueryHookResult = ReturnType<typeof useGetMediaPlayerDataQuery>;
export type GetMediaPlayerDataLazyQueryHookResult = ReturnType<typeof useGetMediaPlayerDataLazyQuery>;
export type GetMediaPlayerDataQueryResult = Apollo.QueryResult<SchemaTypes.GetMediaPlayerDataQuery, SchemaTypes.GetMediaPlayerDataQueryVariables>;
export const GetMediaRecommendationsDocument = gql`
    query GetMediaRecommendations($mediaIri: String!) {
  recommendationsForMedia(mediaIri: $mediaIri) {
    id
    iri
    title
    slug
    contentType
    mediaType
    shortDescription
    teaserDescription
    seriesSlug
    teaserImageFormats {
      sixteenByNine {
        medium
      }
    }
  }
}
    `;

/**
 * __useGetMediaRecommendationsQuery__
 *
 * To run a query within a React component, call `useGetMediaRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMediaRecommendationsQuery({
 *   variables: {
 *      mediaIri: // value for 'mediaIri'
 *   },
 * });
 */
export function useGetMediaRecommendationsQuery(baseOptions: Apollo.QueryHookOptions<SchemaTypes.GetMediaRecommendationsQuery, SchemaTypes.GetMediaRecommendationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaTypes.GetMediaRecommendationsQuery, SchemaTypes.GetMediaRecommendationsQueryVariables>(GetMediaRecommendationsDocument, options);
      }
export function useGetMediaRecommendationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaTypes.GetMediaRecommendationsQuery, SchemaTypes.GetMediaRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaTypes.GetMediaRecommendationsQuery, SchemaTypes.GetMediaRecommendationsQueryVariables>(GetMediaRecommendationsDocument, options);
        }
export type GetMediaRecommendationsQueryHookResult = ReturnType<typeof useGetMediaRecommendationsQuery>;
export type GetMediaRecommendationsLazyQueryHookResult = ReturnType<typeof useGetMediaRecommendationsLazyQuery>;
export type GetMediaRecommendationsQueryResult = Apollo.QueryResult<SchemaTypes.GetMediaRecommendationsQuery, SchemaTypes.GetMediaRecommendationsQueryVariables>;
export const GetNavigationDocument = gql`
    query GetNavigation($name: String!) {
  navigationByName(name: $name) {
    id
    name
    items {
      id
      slug
      language
      title
      subMenu
    }
  }
}
    `;

/**
 * __useGetNavigationQuery__
 *
 * To run a query within a React component, call `useGetNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNavigationQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetNavigationQuery(baseOptions: Apollo.QueryHookOptions<SchemaTypes.GetNavigationQuery, SchemaTypes.GetNavigationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaTypes.GetNavigationQuery, SchemaTypes.GetNavigationQueryVariables>(GetNavigationDocument, options);
      }
export function useGetNavigationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaTypes.GetNavigationQuery, SchemaTypes.GetNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaTypes.GetNavigationQuery, SchemaTypes.GetNavigationQueryVariables>(GetNavigationDocument, options);
        }
export type GetNavigationQueryHookResult = ReturnType<typeof useGetNavigationQuery>;
export type GetNavigationLazyQueryHookResult = ReturnType<typeof useGetNavigationLazyQuery>;
export type GetNavigationQueryResult = Apollo.QueryResult<SchemaTypes.GetNavigationQuery, SchemaTypes.GetNavigationQueryVariables>;
export const GetOrderDocument = gql`
    query GetOrder($orderId: Int!) {
  order(orderId: $orderId) {
    id
    bookingNumber
    lifetime
    media {
      ...MediaTeaser
      shortDescription
    }
    paidAt
    product {
      id
      rentEndDate
      iri
    }
    refNumber
    rentEndDate
    status
    totalAmount
  }
}
    ${MediaTeaserFragmentDoc}`;

/**
 * __useGetOrderQuery__
 *
 * To run a query within a React component, call `useGetOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useGetOrderQuery(baseOptions: Apollo.QueryHookOptions<SchemaTypes.GetOrderQuery, SchemaTypes.GetOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaTypes.GetOrderQuery, SchemaTypes.GetOrderQueryVariables>(GetOrderDocument, options);
      }
export function useGetOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaTypes.GetOrderQuery, SchemaTypes.GetOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaTypes.GetOrderQuery, SchemaTypes.GetOrderQueryVariables>(GetOrderDocument, options);
        }
export type GetOrderQueryHookResult = ReturnType<typeof useGetOrderQuery>;
export type GetOrderLazyQueryHookResult = ReturnType<typeof useGetOrderLazyQuery>;
export type GetOrderQueryResult = Apollo.QueryResult<SchemaTypes.GetOrderQuery, SchemaTypes.GetOrderQueryVariables>;
export const GetOrdersDocument = gql`
    query GetOrders {
  orders {
    id
    status
    bookingNumber
    totalAmount
    media {
      ...MediaTeaser
    }
  }
}
    ${MediaTeaserFragmentDoc}`;

/**
 * __useGetOrdersQuery__
 *
 * To run a query within a React component, call `useGetOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrdersQuery(baseOptions?: Apollo.QueryHookOptions<SchemaTypes.GetOrdersQuery, SchemaTypes.GetOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaTypes.GetOrdersQuery, SchemaTypes.GetOrdersQueryVariables>(GetOrdersDocument, options);
      }
export function useGetOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaTypes.GetOrdersQuery, SchemaTypes.GetOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaTypes.GetOrdersQuery, SchemaTypes.GetOrdersQueryVariables>(GetOrdersDocument, options);
        }
export type GetOrdersQueryHookResult = ReturnType<typeof useGetOrdersQuery>;
export type GetOrdersLazyQueryHookResult = ReturnType<typeof useGetOrdersLazyQuery>;
export type GetOrdersQueryResult = Apollo.QueryResult<SchemaTypes.GetOrdersQuery, SchemaTypes.GetOrdersQueryVariables>;
export const GetPageDocument = gql`
    query GetPage($slug: String!, $locale: AllowedLocales) {
  page(slug: $slug, locale: $locale) {
    id
    contentType
    documentIri
    document {
      id
      title
      description
      theme {
        id
        contentUrl
        backgroundImageFormats {
          sixteenByNine {
            medium
          }
        }
      }
      translationGroup {
        id
        iri
        translations {
          de
          en
          fr
        }
      }
      blocks {
        ...BannerDocumentBlock
        ...ContinueWatchingDocumentBlock
        ...LivestreamBannerDocumentBlock
        ...RasterDocumentBlock
        ...RemoteContentDocumentBlock
        ...SliderDocumentBlock
        ...TeaserlaneDocumentBlock
        ...TeaserlaneGenericDocumentBlock
        ...TextDocumentBlock
      }
    }
  }
}
    ${BannerDocumentBlockFragmentDoc}
${ContinueWatchingDocumentBlockFragmentDoc}
${LivestreamBannerDocumentBlockFragmentDoc}
${RasterDocumentBlockFragmentDoc}
${RemoteContentDocumentBlockFragmentDoc}
${SliderDocumentBlockFragmentDoc}
${TeaserlaneDocumentBlockFragmentDoc}
${TeaserlaneGenericDocumentBlockFragmentDoc}
${TextDocumentBlockFragmentDoc}`;

/**
 * __useGetPageQuery__
 *
 * To run a query within a React component, call `useGetPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGetPageQuery(baseOptions: Apollo.QueryHookOptions<SchemaTypes.GetPageQuery, SchemaTypes.GetPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaTypes.GetPageQuery, SchemaTypes.GetPageQueryVariables>(GetPageDocument, options);
      }
export function useGetPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaTypes.GetPageQuery, SchemaTypes.GetPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaTypes.GetPageQuery, SchemaTypes.GetPageQueryVariables>(GetPageDocument, options);
        }
export type GetPageQueryHookResult = ReturnType<typeof useGetPageQuery>;
export type GetPageLazyQueryHookResult = ReturnType<typeof useGetPageLazyQuery>;
export type GetPageQueryResult = Apollo.QueryResult<SchemaTypes.GetPageQuery, SchemaTypes.GetPageQueryVariables>;
export const GetPreviewPageDocument = gql`
    query GetPreviewPage($documentIri: String!) {
  document(documentIri: $documentIri) {
    id
    title
    description
    theme {
      id
      contentUrl
      backgroundImageFormats {
        sixteenByNine {
          medium
        }
      }
    }
    translationGroup {
      id
      iri
      translations {
        de
        en
        fr
      }
    }
    blocks {
      ...BannerDocumentBlock
      ...ContinueWatchingDocumentBlock
      ...LivestreamBannerDocumentBlock
      ...RasterDocumentBlock
      ...RemoteContentDocumentBlock
      ...SliderDocumentBlock
      ...TeaserlaneDocumentBlock
      ...TeaserlaneGenericDocumentBlock
      ...TextDocumentBlock
    }
  }
}
    ${BannerDocumentBlockFragmentDoc}
${ContinueWatchingDocumentBlockFragmentDoc}
${LivestreamBannerDocumentBlockFragmentDoc}
${RasterDocumentBlockFragmentDoc}
${RemoteContentDocumentBlockFragmentDoc}
${SliderDocumentBlockFragmentDoc}
${TeaserlaneDocumentBlockFragmentDoc}
${TeaserlaneGenericDocumentBlockFragmentDoc}
${TextDocumentBlockFragmentDoc}`;

/**
 * __useGetPreviewPageQuery__
 *
 * To run a query within a React component, call `useGetPreviewPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewPageQuery({
 *   variables: {
 *      documentIri: // value for 'documentIri'
 *   },
 * });
 */
export function useGetPreviewPageQuery(baseOptions: Apollo.QueryHookOptions<SchemaTypes.GetPreviewPageQuery, SchemaTypes.GetPreviewPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaTypes.GetPreviewPageQuery, SchemaTypes.GetPreviewPageQueryVariables>(GetPreviewPageDocument, options);
      }
export function useGetPreviewPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaTypes.GetPreviewPageQuery, SchemaTypes.GetPreviewPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaTypes.GetPreviewPageQuery, SchemaTypes.GetPreviewPageQueryVariables>(GetPreviewPageDocument, options);
        }
export type GetPreviewPageQueryHookResult = ReturnType<typeof useGetPreviewPageQuery>;
export type GetPreviewPageLazyQueryHookResult = ReturnType<typeof useGetPreviewPageLazyQuery>;
export type GetPreviewPageQueryResult = Apollo.QueryResult<SchemaTypes.GetPreviewPageQuery, SchemaTypes.GetPreviewPageQueryVariables>;
export const GetSearchResultsDocument = gql`
    query GetSearchResults($params: SearchParams!) {
  search(params: $params) {
    items {
      ...MediaTeaser
      ...StudioTeaser
      ...CategoryTeaser
      ...SeriesTeaser
    }
    hasMore
    page
  }
}
    ${MediaTeaserFragmentDoc}
${StudioTeaserFragmentDoc}
${CategoryTeaserFragmentDoc}
${SeriesTeaserFragmentDoc}`;

/**
 * __useGetSearchResultsQuery__
 *
 * To run a query within a React component, call `useGetSearchResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchResultsQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetSearchResultsQuery(baseOptions: Apollo.QueryHookOptions<SchemaTypes.GetSearchResultsQuery, SchemaTypes.GetSearchResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaTypes.GetSearchResultsQuery, SchemaTypes.GetSearchResultsQueryVariables>(GetSearchResultsDocument, options);
      }
export function useGetSearchResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaTypes.GetSearchResultsQuery, SchemaTypes.GetSearchResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaTypes.GetSearchResultsQuery, SchemaTypes.GetSearchResultsQueryVariables>(GetSearchResultsDocument, options);
        }
export type GetSearchResultsQueryHookResult = ReturnType<typeof useGetSearchResultsQuery>;
export type GetSearchResultsLazyQueryHookResult = ReturnType<typeof useGetSearchResultsLazyQuery>;
export type GetSearchResultsQueryResult = Apollo.QueryResult<SchemaTypes.GetSearchResultsQuery, SchemaTypes.GetSearchResultsQueryVariables>;
export const GetSearchResultsCountDocument = gql`
    query GetSearchResultsCount($params: SearchParams!) {
  searchWithFacets(params: $params) {
    totalItems
    hasMore
    page
  }
}
    `;

/**
 * __useGetSearchResultsCountQuery__
 *
 * To run a query within a React component, call `useGetSearchResultsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchResultsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchResultsCountQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetSearchResultsCountQuery(baseOptions: Apollo.QueryHookOptions<SchemaTypes.GetSearchResultsCountQuery, SchemaTypes.GetSearchResultsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaTypes.GetSearchResultsCountQuery, SchemaTypes.GetSearchResultsCountQueryVariables>(GetSearchResultsCountDocument, options);
      }
export function useGetSearchResultsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaTypes.GetSearchResultsCountQuery, SchemaTypes.GetSearchResultsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaTypes.GetSearchResultsCountQuery, SchemaTypes.GetSearchResultsCountQueryVariables>(GetSearchResultsCountDocument, options);
        }
export type GetSearchResultsCountQueryHookResult = ReturnType<typeof useGetSearchResultsCountQuery>;
export type GetSearchResultsCountLazyQueryHookResult = ReturnType<typeof useGetSearchResultsCountLazyQuery>;
export type GetSearchResultsCountQueryResult = Apollo.QueryResult<SchemaTypes.GetSearchResultsCountQuery, SchemaTypes.GetSearchResultsCountQueryVariables>;
export const GetSearchResultsWithFacetsDocument = gql`
    query GetSearchResultsWithFacets($params: SearchParams!) {
  searchWithFacets(params: $params) {
    items {
      ...MediaTeaser
      ...StudioTeaser
      ...CategoryTeaser
      ...SeriesTeaser
    }
    facets {
      ... on CountFacet {
        name
        type
        label
        values {
          value
          count
          label
          slug
        }
      }
      ... on DateTimeFacet {
        name
        type
        value
        label
      }
    }
    hasMore
    page
  }
}
    ${MediaTeaserFragmentDoc}
${StudioTeaserFragmentDoc}
${CategoryTeaserFragmentDoc}
${SeriesTeaserFragmentDoc}`;

/**
 * __useGetSearchResultsWithFacetsQuery__
 *
 * To run a query within a React component, call `useGetSearchResultsWithFacetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchResultsWithFacetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchResultsWithFacetsQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetSearchResultsWithFacetsQuery(baseOptions: Apollo.QueryHookOptions<SchemaTypes.GetSearchResultsWithFacetsQuery, SchemaTypes.GetSearchResultsWithFacetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaTypes.GetSearchResultsWithFacetsQuery, SchemaTypes.GetSearchResultsWithFacetsQueryVariables>(GetSearchResultsWithFacetsDocument, options);
      }
export function useGetSearchResultsWithFacetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaTypes.GetSearchResultsWithFacetsQuery, SchemaTypes.GetSearchResultsWithFacetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaTypes.GetSearchResultsWithFacetsQuery, SchemaTypes.GetSearchResultsWithFacetsQueryVariables>(GetSearchResultsWithFacetsDocument, options);
        }
export type GetSearchResultsWithFacetsQueryHookResult = ReturnType<typeof useGetSearchResultsWithFacetsQuery>;
export type GetSearchResultsWithFacetsLazyQueryHookResult = ReturnType<typeof useGetSearchResultsWithFacetsLazyQuery>;
export type GetSearchResultsWithFacetsQueryResult = Apollo.QueryResult<SchemaTypes.GetSearchResultsWithFacetsQuery, SchemaTypes.GetSearchResultsWithFacetsQueryVariables>;
export const GetSearchSuggestionsDocument = gql`
    query GetSearchSuggestions($params: SearchParams!) {
  search(params: $params) {
    items {
      ... on Media {
        id
        iri
        contentType
        mediaType
        title
        slug
        seriesSlug
        liveDate
      }
      ... on Series {
        id
        iri
        contentType
        title
        slug
      }
      ... on Category {
        id
        iri
        contentType
        title
        slug
      }
      ... on Studio {
        id
        iri
        contentType
        title
        slug
      }
    }
    hasMore
    page
  }
}
    `;

/**
 * __useGetSearchSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetSearchSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchSuggestionsQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetSearchSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<SchemaTypes.GetSearchSuggestionsQuery, SchemaTypes.GetSearchSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaTypes.GetSearchSuggestionsQuery, SchemaTypes.GetSearchSuggestionsQueryVariables>(GetSearchSuggestionsDocument, options);
      }
export function useGetSearchSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaTypes.GetSearchSuggestionsQuery, SchemaTypes.GetSearchSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaTypes.GetSearchSuggestionsQuery, SchemaTypes.GetSearchSuggestionsQueryVariables>(GetSearchSuggestionsDocument, options);
        }
export type GetSearchSuggestionsQueryHookResult = ReturnType<typeof useGetSearchSuggestionsQuery>;
export type GetSearchSuggestionsLazyQueryHookResult = ReturnType<typeof useGetSearchSuggestionsLazyQuery>;
export type GetSearchSuggestionsQueryResult = Apollo.QueryResult<SchemaTypes.GetSearchSuggestionsQuery, SchemaTypes.GetSearchSuggestionsQueryVariables>;
export const GetSeasonsForSeriesDocument = gql`
    query GetSeasonsForSeries($seriesId: Int!) {
  seriesById(seriesId: $seriesId) {
    id
    seasons {
      id
      title
      description
      seasonNumber
      label {
        title
      }
    }
    hideSeasonNumbers
  }
}
    `;

/**
 * __useGetSeasonsForSeriesQuery__
 *
 * To run a query within a React component, call `useGetSeasonsForSeriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeasonsForSeriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeasonsForSeriesQuery({
 *   variables: {
 *      seriesId: // value for 'seriesId'
 *   },
 * });
 */
export function useGetSeasonsForSeriesQuery(baseOptions: Apollo.QueryHookOptions<SchemaTypes.GetSeasonsForSeriesQuery, SchemaTypes.GetSeasonsForSeriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaTypes.GetSeasonsForSeriesQuery, SchemaTypes.GetSeasonsForSeriesQueryVariables>(GetSeasonsForSeriesDocument, options);
      }
export function useGetSeasonsForSeriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaTypes.GetSeasonsForSeriesQuery, SchemaTypes.GetSeasonsForSeriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaTypes.GetSeasonsForSeriesQuery, SchemaTypes.GetSeasonsForSeriesQueryVariables>(GetSeasonsForSeriesDocument, options);
        }
export type GetSeasonsForSeriesQueryHookResult = ReturnType<typeof useGetSeasonsForSeriesQuery>;
export type GetSeasonsForSeriesLazyQueryHookResult = ReturnType<typeof useGetSeasonsForSeriesLazyQuery>;
export type GetSeasonsForSeriesQueryResult = Apollo.QueryResult<SchemaTypes.GetSeasonsForSeriesQuery, SchemaTypes.GetSeasonsForSeriesQueryVariables>;
export const GetSeriesEpisodePageDocument = gql`
    query GetSeriesEpisodePage($seriesSlug: String!, $episodeSlug: String!) {
  seriesEpisode(seriesSlug: $seriesSlug, episodeSlug: $episodeSlug) {
    id
    iri
    attributes {
      id
      name
      type
      values
      isSearchable
    }
    availableQualities
    backgroundImageFormats {
      sixteenByNine {
        large
      }
      threeByFive {
        medium
      }
    }
    categories {
      id
      iri
      contentType
      slug
      title
    }
    contentType
    details {
      id
      streamState
      startDate
      endDate
    }
    description
    episodeNumber
    extras {
      ...MediaTeaser
    }
    fskRating
    killDate
    leadin
    liveDate
    logoImageFormats {
      oneByOne {
        medium
      }
      sixteenBySeven {
        medium
      }
    }
    mediaDuration
    mediaLanguages
    mediaQuality
    mediaType
    products {
      access {
        allowed
        endDate
        period
        reason
      }
      availableProducts {
        id
        iri
        lifetime
        price
        type
      }
    }
    recommendations {
      ...MediaTeaser
    }
    series {
      id
      iri
      contentType
      slug
      title
    }
    seriesSlug
    shortDescription
    slug
    studio {
      id
      iri
      contentType
      slug
      title
      logoImageFormats {
        oneByOne {
          small
        }
      }
    }
    subtitleLanguages
    teaserDescription
    teaserImageFormats {
      sixteenByNine {
        medium
      }
    }
    title
    trailers {
      id
      contentType
      iri
      mediaType
      slug
      title
    }
    year
    geoRestrictions {
      allowedRegions
      deniedRegions
    }
    tags
    season {
      id
      seasonNumber
    }
    theme {
      id
      title
    }
  }
}
    ${MediaTeaserFragmentDoc}`;

/**
 * __useGetSeriesEpisodePageQuery__
 *
 * To run a query within a React component, call `useGetSeriesEpisodePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeriesEpisodePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeriesEpisodePageQuery({
 *   variables: {
 *      seriesSlug: // value for 'seriesSlug'
 *      episodeSlug: // value for 'episodeSlug'
 *   },
 * });
 */
export function useGetSeriesEpisodePageQuery(baseOptions: Apollo.QueryHookOptions<SchemaTypes.GetSeriesEpisodePageQuery, SchemaTypes.GetSeriesEpisodePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaTypes.GetSeriesEpisodePageQuery, SchemaTypes.GetSeriesEpisodePageQueryVariables>(GetSeriesEpisodePageDocument, options);
      }
export function useGetSeriesEpisodePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaTypes.GetSeriesEpisodePageQuery, SchemaTypes.GetSeriesEpisodePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaTypes.GetSeriesEpisodePageQuery, SchemaTypes.GetSeriesEpisodePageQueryVariables>(GetSeriesEpisodePageDocument, options);
        }
export type GetSeriesEpisodePageQueryHookResult = ReturnType<typeof useGetSeriesEpisodePageQuery>;
export type GetSeriesEpisodePageLazyQueryHookResult = ReturnType<typeof useGetSeriesEpisodePageLazyQuery>;
export type GetSeriesEpisodePageQueryResult = Apollo.QueryResult<SchemaTypes.GetSeriesEpisodePageQuery, SchemaTypes.GetSeriesEpisodePageQueryVariables>;
export const GetSeriesPageDocument = gql`
    query GetSeriesPage($slug: String!) {
  seriesBySlug(slug: $slug) {
    id
    title
    slug
    iri
    categories {
      id
      iri
      contentType
      slug
      title
    }
    contentType
    description
    leadin
    type
    shortDescription
    teaserDescription
    studio {
      id
      iri
      contentType
      slug
      title
      logoImageFormats {
        oneByOne {
          small
        }
      }
    }
    logoImageFormats {
      sixteenBySeven {
        medium
      }
      oneByOne {
        small
      }
    }
    backgroundImageFormats {
      sixteenByNine {
        large
      }
      threeByFive {
        medium
      }
    }
    teaserImageFormats {
      sixteenByNine {
        large
      }
    }
    extras {
      id
      iri
      contentType
      title
      slug
      teaserImageFormats {
        sixteenByNine {
          medium
        }
      }
    }
    trailers {
      id
      iri
      contentType
      title
      slug
    }
    year
  }
}
    `;

/**
 * __useGetSeriesPageQuery__
 *
 * To run a query within a React component, call `useGetSeriesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeriesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeriesPageQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetSeriesPageQuery(baseOptions: Apollo.QueryHookOptions<SchemaTypes.GetSeriesPageQuery, SchemaTypes.GetSeriesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaTypes.GetSeriesPageQuery, SchemaTypes.GetSeriesPageQueryVariables>(GetSeriesPageDocument, options);
      }
export function useGetSeriesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaTypes.GetSeriesPageQuery, SchemaTypes.GetSeriesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaTypes.GetSeriesPageQuery, SchemaTypes.GetSeriesPageQueryVariables>(GetSeriesPageDocument, options);
        }
export type GetSeriesPageQueryHookResult = ReturnType<typeof useGetSeriesPageQuery>;
export type GetSeriesPageLazyQueryHookResult = ReturnType<typeof useGetSeriesPageLazyQuery>;
export type GetSeriesPageQueryResult = Apollo.QueryResult<SchemaTypes.GetSeriesPageQuery, SchemaTypes.GetSeriesPageQueryVariables>;
export const GetSeriesPlaybackStateDocument = gql`
    query GetSeriesPlaybackState($id: Int!, $profileId: Int) {
  seriesById(seriesId: $id) {
    id
    iri
    title
    teaserDescription
    contentType
    trailers {
      id
      iri
      contentType
      title
      slug
    }
    currentEpisode(profileId: $profileId) {
      ...MediaTeaser
      products {
        access {
          allowed
          product {
            id
            iri
          }
          reason
        }
        availableProducts {
          id
          iri
          price
          type
        }
      }
    }
  }
}
    ${MediaTeaserFragmentDoc}`;

/**
 * __useGetSeriesPlaybackStateQuery__
 *
 * To run a query within a React component, call `useGetSeriesPlaybackStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeriesPlaybackStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeriesPlaybackStateQuery({
 *   variables: {
 *      id: // value for 'id'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useGetSeriesPlaybackStateQuery(baseOptions: Apollo.QueryHookOptions<SchemaTypes.GetSeriesPlaybackStateQuery, SchemaTypes.GetSeriesPlaybackStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaTypes.GetSeriesPlaybackStateQuery, SchemaTypes.GetSeriesPlaybackStateQueryVariables>(GetSeriesPlaybackStateDocument, options);
      }
export function useGetSeriesPlaybackStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaTypes.GetSeriesPlaybackStateQuery, SchemaTypes.GetSeriesPlaybackStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaTypes.GetSeriesPlaybackStateQuery, SchemaTypes.GetSeriesPlaybackStateQueryVariables>(GetSeriesPlaybackStateDocument, options);
        }
export type GetSeriesPlaybackStateQueryHookResult = ReturnType<typeof useGetSeriesPlaybackStateQuery>;
export type GetSeriesPlaybackStateLazyQueryHookResult = ReturnType<typeof useGetSeriesPlaybackStateLazyQuery>;
export type GetSeriesPlaybackStateQueryResult = Apollo.QueryResult<SchemaTypes.GetSeriesPlaybackStateQuery, SchemaTypes.GetSeriesPlaybackStateQueryVariables>;
export const GetSeriesPlaylistDocument = gql`
    query GetSeriesPlaylist($seriesId: Int) {
  seriesPlaylist(seriesId: $seriesId) {
    id
    endCreditsTimeMarker
    episodeIri
    episodeNumber
    seasonNumber
    seasonIri
  }
}
    `;

/**
 * __useGetSeriesPlaylistQuery__
 *
 * To run a query within a React component, call `useGetSeriesPlaylistQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSeriesPlaylistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSeriesPlaylistQuery({
 *   variables: {
 *      seriesId: // value for 'seriesId'
 *   },
 * });
 */
export function useGetSeriesPlaylistQuery(baseOptions?: Apollo.QueryHookOptions<SchemaTypes.GetSeriesPlaylistQuery, SchemaTypes.GetSeriesPlaylistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaTypes.GetSeriesPlaylistQuery, SchemaTypes.GetSeriesPlaylistQueryVariables>(GetSeriesPlaylistDocument, options);
      }
export function useGetSeriesPlaylistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaTypes.GetSeriesPlaylistQuery, SchemaTypes.GetSeriesPlaylistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaTypes.GetSeriesPlaylistQuery, SchemaTypes.GetSeriesPlaylistQueryVariables>(GetSeriesPlaylistDocument, options);
        }
export type GetSeriesPlaylistQueryHookResult = ReturnType<typeof useGetSeriesPlaylistQuery>;
export type GetSeriesPlaylistLazyQueryHookResult = ReturnType<typeof useGetSeriesPlaylistLazyQuery>;
export type GetSeriesPlaylistQueryResult = Apollo.QueryResult<SchemaTypes.GetSeriesPlaylistQuery, SchemaTypes.GetSeriesPlaylistQueryVariables>;
export const GetStudioPageDocument = gql`
    query GetStudioPage($slug: String!) {
  studioBySlug(slug: $slug) {
    id
    contentType
    description
    shortDescription
    teaserDescription
    title
    medias {
      ...MediaTeaser
    }
    series {
      ...SeriesTeaser
    }
    logoImageFormats {
      sixteenBySeven {
        medium
      }
      oneByOne {
        small
      }
    }
    teaserImageFormats {
      sixteenByNine {
        medium
      }
    }
    backgroundImageFormats {
      sixteenByNine {
        large
      }
      threeByFive {
        medium
      }
    }
  }
}
    ${MediaTeaserFragmentDoc}
${SeriesTeaserFragmentDoc}`;

/**
 * __useGetStudioPageQuery__
 *
 * To run a query within a React component, call `useGetStudioPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudioPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudioPageQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetStudioPageQuery(baseOptions: Apollo.QueryHookOptions<SchemaTypes.GetStudioPageQuery, SchemaTypes.GetStudioPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaTypes.GetStudioPageQuery, SchemaTypes.GetStudioPageQueryVariables>(GetStudioPageDocument, options);
      }
export function useGetStudioPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaTypes.GetStudioPageQuery, SchemaTypes.GetStudioPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaTypes.GetStudioPageQuery, SchemaTypes.GetStudioPageQueryVariables>(GetStudioPageDocument, options);
        }
export type GetStudioPageQueryHookResult = ReturnType<typeof useGetStudioPageQuery>;
export type GetStudioPageLazyQueryHookResult = ReturnType<typeof useGetStudioPageLazyQuery>;
export type GetStudioPageQueryResult = Apollo.QueryResult<SchemaTypes.GetStudioPageQuery, SchemaTypes.GetStudioPageQueryVariables>;
export const GetTeaserDocument = gql`
    query GetTeaser($path: String!) {
  teaser(path: $path) {
    ...MediaTeaser
    ...SeriesTeaser
    ...CategoryTeaser
    ...StudioTeaser
  }
}
    ${MediaTeaserFragmentDoc}
${SeriesTeaserFragmentDoc}
${CategoryTeaserFragmentDoc}
${StudioTeaserFragmentDoc}`;

/**
 * __useGetTeaserQuery__
 *
 * To run a query within a React component, call `useGetTeaserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeaserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeaserQuery({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function useGetTeaserQuery(baseOptions: Apollo.QueryHookOptions<SchemaTypes.GetTeaserQuery, SchemaTypes.GetTeaserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaTypes.GetTeaserQuery, SchemaTypes.GetTeaserQueryVariables>(GetTeaserDocument, options);
      }
export function useGetTeaserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaTypes.GetTeaserQuery, SchemaTypes.GetTeaserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaTypes.GetTeaserQuery, SchemaTypes.GetTeaserQueryVariables>(GetTeaserDocument, options);
        }
export type GetTeaserQueryHookResult = ReturnType<typeof useGetTeaserQuery>;
export type GetTeaserLazyQueryHookResult = ReturnType<typeof useGetTeaserLazyQuery>;
export type GetTeaserQueryResult = Apollo.QueryResult<SchemaTypes.GetTeaserQuery, SchemaTypes.GetTeaserQueryVariables>;
export const GetTeaserCollectionDocument = gql`
    query GetTeaserCollection($params: TeaserCollectionParams!) {
  teaserCollection(params: $params) {
    items {
      ...MediaTeaser
      ...StudioTeaser
      ...CategoryTeaser
      ...SeriesTeaser
    }
    page
    totalItems
    hasMore
  }
}
    ${MediaTeaserFragmentDoc}
${StudioTeaserFragmentDoc}
${CategoryTeaserFragmentDoc}
${SeriesTeaserFragmentDoc}`;

/**
 * __useGetTeaserCollectionQuery__
 *
 * To run a query within a React component, call `useGetTeaserCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeaserCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeaserCollectionQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetTeaserCollectionQuery(baseOptions: Apollo.QueryHookOptions<SchemaTypes.GetTeaserCollectionQuery, SchemaTypes.GetTeaserCollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaTypes.GetTeaserCollectionQuery, SchemaTypes.GetTeaserCollectionQueryVariables>(GetTeaserCollectionDocument, options);
      }
export function useGetTeaserCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaTypes.GetTeaserCollectionQuery, SchemaTypes.GetTeaserCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaTypes.GetTeaserCollectionQuery, SchemaTypes.GetTeaserCollectionQueryVariables>(GetTeaserCollectionDocument, options);
        }
export type GetTeaserCollectionQueryHookResult = ReturnType<typeof useGetTeaserCollectionQuery>;
export type GetTeaserCollectionLazyQueryHookResult = ReturnType<typeof useGetTeaserCollectionLazyQuery>;
export type GetTeaserCollectionQueryResult = Apollo.QueryResult<SchemaTypes.GetTeaserCollectionQuery, SchemaTypes.GetTeaserCollectionQueryVariables>;
export const GetTeasersDocument = gql`
    query GetTeasers($paths: [String!]!) {
  teasers(paths: $paths) {
    __typename
    ... on Media {
      id
      iri
      contentType
      details {
        id
        streamState
        startDate
        endDate
      }
      title
      slug
      seriesSlug
      categories {
        id
        title
        slug
        contentType
      }
      fskRating
      mediaDuration
      mediaQuality
      mediaType
      teaserDescription
      teaserImageFormats {
        sixteenByNine {
          medium
        }
        threeByFour {
          medium
        }
      }
    }
    ...CategoryTeaser
    ...StudioTeaser
    ...SeriesTeaser
  }
}
    ${CategoryTeaserFragmentDoc}
${StudioTeaserFragmentDoc}
${SeriesTeaserFragmentDoc}`;

/**
 * __useGetTeasersQuery__
 *
 * To run a query within a React component, call `useGetTeasersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeasersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeasersQuery({
 *   variables: {
 *      paths: // value for 'paths'
 *   },
 * });
 */
export function useGetTeasersQuery(baseOptions: Apollo.QueryHookOptions<SchemaTypes.GetTeasersQuery, SchemaTypes.GetTeasersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaTypes.GetTeasersQuery, SchemaTypes.GetTeasersQueryVariables>(GetTeasersDocument, options);
      }
export function useGetTeasersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaTypes.GetTeasersQuery, SchemaTypes.GetTeasersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaTypes.GetTeasersQuery, SchemaTypes.GetTeasersQueryVariables>(GetTeasersDocument, options);
        }
export type GetTeasersQueryHookResult = ReturnType<typeof useGetTeasersQuery>;
export type GetTeasersLazyQueryHookResult = ReturnType<typeof useGetTeasersLazyQuery>;
export type GetTeasersQueryResult = Apollo.QueryResult<SchemaTypes.GetTeasersQuery, SchemaTypes.GetTeasersQueryVariables>;
export const GetTeasersByPathsDocument = gql`
    query GetTeasersByPaths($paths: [String!]!) {
  mediasByPaths(paths: $paths) {
    ...MediaTeaser
  }
}
    ${MediaTeaserFragmentDoc}`;

/**
 * __useGetTeasersByPathsQuery__
 *
 * To run a query within a React component, call `useGetTeasersByPathsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeasersByPathsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeasersByPathsQuery({
 *   variables: {
 *      paths: // value for 'paths'
 *   },
 * });
 */
export function useGetTeasersByPathsQuery(baseOptions: Apollo.QueryHookOptions<SchemaTypes.GetTeasersByPathsQuery, SchemaTypes.GetTeasersByPathsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaTypes.GetTeasersByPathsQuery, SchemaTypes.GetTeasersByPathsQueryVariables>(GetTeasersByPathsDocument, options);
      }
export function useGetTeasersByPathsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaTypes.GetTeasersByPathsQuery, SchemaTypes.GetTeasersByPathsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaTypes.GetTeasersByPathsQuery, SchemaTypes.GetTeasersByPathsQueryVariables>(GetTeasersByPathsDocument, options);
        }
export type GetTeasersByPathsQueryHookResult = ReturnType<typeof useGetTeasersByPathsQuery>;
export type GetTeasersByPathsLazyQueryHookResult = ReturnType<typeof useGetTeasersByPathsLazyQuery>;
export type GetTeasersByPathsQueryResult = Apollo.QueryResult<SchemaTypes.GetTeasersByPathsQuery, SchemaTypes.GetTeasersByPathsQueryVariables>;
export const UpdateContinueWatchingItemDocument = gql`
    mutation UpdateContinueWatchingItem($params: UpdateContinueWatchingItemParams!) {
  updateContinueWatchingItem(params: $params) {
    id
    currentTime
    mediaDuration
    mediaIri
    modifiedAt
    profileId
    seriesIri
    state
  }
}
    `;
export type UpdateContinueWatchingItemMutationFn = Apollo.MutationFunction<SchemaTypes.UpdateContinueWatchingItemMutation, SchemaTypes.UpdateContinueWatchingItemMutationVariables>;

/**
 * __useUpdateContinueWatchingItemMutation__
 *
 * To run a mutation, you first call `useUpdateContinueWatchingItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContinueWatchingItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContinueWatchingItemMutation, { data, loading, error }] = useUpdateContinueWatchingItemMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateContinueWatchingItemMutation(baseOptions?: Apollo.MutationHookOptions<SchemaTypes.UpdateContinueWatchingItemMutation, SchemaTypes.UpdateContinueWatchingItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SchemaTypes.UpdateContinueWatchingItemMutation, SchemaTypes.UpdateContinueWatchingItemMutationVariables>(UpdateContinueWatchingItemDocument, options);
      }
export type UpdateContinueWatchingItemMutationHookResult = ReturnType<typeof useUpdateContinueWatchingItemMutation>;
export type UpdateContinueWatchingItemMutationResult = Apollo.MutationResult<SchemaTypes.UpdateContinueWatchingItemMutation>;
export type UpdateContinueWatchingItemMutationOptions = Apollo.BaseMutationOptions<SchemaTypes.UpdateContinueWatchingItemMutation, SchemaTypes.UpdateContinueWatchingItemMutationVariables>;